import mutations from "./../mutations";
import axios from "axios";
import router from "./../../router";
import uri from "./../config";

const { SET_STATISTICS, SET_STATUS, SET_UPDATED_STATISTIC, SET_ARCHIVE, SET_TOTAL, DELETE_ARCHIVE, SET_BEFORE_STATISTIC, SET_ARCHIVES, SET_TOTALS_MONTH, SET_BRIGADES, SET_ERROR_BRIGADES, SET_BRIGADES_BY_DATE, SET_BRIGADE_BY_DATE } = mutations;

const statisticStore = {
  state: {
    statistics: [],
    brigades: [],
    bridades_by_date: [],
    before_statistic: {},
    archive: {},
    archives: [],
    user: [],
    users: [],
    totals: null,
    totals_month: {},
    current_date: new Date(),
    error_brigades: false,
  },
  getters: {
    get_statistics: ({ statistics }) => statistics,
    get_brigades: ({ brigades }) => brigades,
    get_bridades_by_date: ({ bridades_by_date }) => bridades_by_date,
    get_before_statistic: ({ before_statistic }) => before_statistic,
    get_totals: ({ totals }) => totals,
    get_totals_month: ({ totals_month }) => totals_month,
    get_archive: ({ archive }) => archive,
    get_error_brigades: ({ error_brigades }) => error_brigades,
    get_archives: ({ archives }) => archives,
    get_status_by_date: (state) => (date) => {
      let current_date_statistic;

      if (state.statistics) {

        state.statistics.forEach((statistic) => {
          if (
            statistic.date ==
            date
              .toLocaleDateString("ru-RU")
              .replace(/\./g, "-")
              .split("-")
              .reverse()
              .join("-")
          )
            current_date_statistic = statistic
          else {
            current_date_statistic = state.statistics.find(stat => stat.status == 'open')
          }
        });

        if (!current_date_statistic) return false;

        return current_date_statistic.status;
      } else return false
    },
    get_products_from_statistic: (state) => (date) => {
      let current_date_statistic;
      console.log('мы попадаем сюда');
      state.statistics.forEach((statistic) => {
        if (
          statistic.date ==
          date
            .toLocaleDateString("ru-RU")
            .replace(/\./g, "-")
            .split("-")
            .reverse()
            .join("-")
        )
          current_date_statistic = statistic
        else {
          current_date_statistic = state.statistics.find(stat => stat.status == 'open')
        }
      });

      if (!current_date_statistic) return false;


      return current_date_statistic.groups;
    },

    get_plan_by_current_date: (state) => {
      const date = state.current_date
        .toLocaleDateString("ru-RU")
        .replace(/\./g, "-")
        .split("-")
        .reverse()
        .join("-");
      return state.statistics.find((plan) => plan.date == date);
    },
    get_archive_by_id: (state, _id) => {
      return state.archive.find((archive) => archive._id == _id);
    },
  },
  mutations: {
    [SET_STATISTICS](state, payload) {
      state.statistics = payload;
    },
    [SET_BRIGADES](state, payload) {
      state.brigades = payload;
    },
    [SET_ARCHIVE](state, payload) {
      state.archive = payload;
    },
    [DELETE_ARCHIVE](state, payload) {
      state.archive = {}
    },
    [SET_STATUS](state, payload) {
      state.statistics = payload;
    },
    [SET_UPDATED_STATISTIC](state, payload) {
      state.statistics = payload;
    },
    [SET_TOTAL](state, payload) {
      state.totals = payload;
    },
    [SET_BEFORE_STATISTIC](state, payload) {
      state.before_statistic = payload;
    },
    [SET_ARCHIVES](state, payload) {
      state.archives = payload;
    },
    [SET_TOTALS_MONTH](state, payload) {
      state.totals_month = payload;
    },
    [SET_ERROR_BRIGADES](state, payload) {
      state.error_brigades = payload;
    },
    [SET_BRIGADES_BY_DATE](state, payload) {
      state.bridades_by_date = payload;
    },
    [SET_BRIGADE_BY_DATE](state, payload) {
      const index = state.bridades_by_date.findIndex(b => b._id === payload.brigade)

      if(index !== -1){
        if(state.bridades_by_date[index].brigade_statistic.length){
          state.bridades_by_date[index].brigade_statistic[0].dpf = payload.dpf
        } else {
          state.bridades_by_date[index].brigade_statistic = []
          state.bridades_by_date[index].brigade_statistic[0] = payload
        }
      }
    },
    
    
  },
  actions: {
    async set_total({ commit }, total) {
      commit(SET_TOTAL, total);
    },
    async load_statistics({ commit }) {

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      instance
        .get("/statistics")
        .then((r) => r.data)
        .then((data) => {

          // убираем продукты с планом 0 из массива данных

          data.stat.groups.forEach(group => {

            group.products = group.products.filter(product => product.plan != 0)
          })

          data.stat.time = data.time
          data.stat.all_dpfs = data.all_dpfs
          commit(SET_STATISTICS, data.stat);
          commit(SET_BRIGADES, data.db_brigades);
          commit(SET_BEFORE_STATISTIC, data.stat_prev_plan);
        })
        .catch((err) => {
          if (err.response && err.response.status == 401) console.log(1234);
        });
    },

    async load_archives({ commit }, data) {

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      instance
        .get(`/statistics/archives/${data.year}/${data.month}`)
        .then((r) => r.data)
        .then((data) => {
          // убираем продукты с планом 0 из массива данных

          // data.archive.forEach(arch => {

          //   arch.groups.forEach(group => {
          //     group.products = group.products.filter(product => product.plan != 0)
          //   })
          // })
          
          commit(SET_ARCHIVES, data.archives);

        })
        .catch((err) => {
          console.log(err)
        });
    },

    async load_archive({ commit }, date) {
      
      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      instance
        .get(`/statistics/archive/${date.date}`)
        .then((res) => {

          if(res.status == 200){
            commit(SET_ARCHIVE, res.data.archive);
            commit(SET_TOTALS_MONTH, res.data.totals);
          }

          // убираем продукты с планом 0 из массива данных

          // data.archive.forEach(arch => {

          //   arch.groups.forEach(group => {
          //     group.products = group.products.filter(product => product.plan != 0)
          //   })
          // })
          
          // commit(SET_ARCHIVE, data.archive);
          // commit(SET_TOTALS_MONTH, data.totals);

        })
        .catch((err) => {
          console.log(err)
        });
    },



    async load_statistics_by_authenticate({ commit }) {
      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      instance
        .get("/statistics/load_statistics_by_authenticate")
        .then((r) => r.data)
        .then((data) => {

          // убираем продукты с планом 0 из массива данных
          data.stat.groups.forEach(group => {
            group.products = group.products.filter(product => product.plan != 0)
          })


          const MAX_WEIGHT = 33
          let sliders = []
          let slider = new Array()
          let counter = 0

          let total_product_plan = 0
          let total_product_fact = 0
          let dpf = 0



          if (data.stat.groups) {
            const local_groups = JSON.parse(JSON.stringify(data.stat.groups))

            local_groups.forEach((group, index) => {
              group.weight = 0

              // считаем итоговые план и факт по продукции
              group.products.forEach((product) => {
                total_product_plan += product.plan
                total_product_fact += product.fact
                dpf += product.ratio * 1 * product.fact

                // оппределяем вес группы на экране
                group.weight += product.accessories.length + 1
              })

              // если группа занимает больше 9 квадратов - значит она занимает несколько строк, иначе отдаем группе всю строку
              group.weight = group.weight > 11 ? Math.ceil(group.weight / 11) * 11 : 11

              if (counter + group.weight <= MAX_WEIGHT) {
                slider.push(group)
                counter += group.weight

                // если группы закончились, кладем их в последний слайдер
                if (index == local_groups.length - 1) sliders.push(slider)
                // если не влазит создаем новый слайдер и обнуляем счетчик веса
              } else {
                sliders.push(slider)
                slider = new Array()
                slider.push(group)
                counter = 0
              }
            })





          }
          let total = {
            total_product_plan,
            total_product_fact,
            dpf,
            percent: ((total_product_fact / total_product_plan) * 100).toFixed(2)
          }
          commit(SET_TOTAL, total);
          commit(SET_STATISTICS, data.stat);
        })
        .catch((err) => {
          if (err.response && err.response.status == 401) router.push("/statistic");
        });
    },

    async set_fact_by_accessorry({ commit }, data) {
      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      instance
        .post("/statistics", { data })
        .then((r) => r.data)
        .then((data) => {

          // убираем продукты с планом 0 из массива данных
          data.groups.forEach(group => {
            group.products = group.products.filter(product => product.plan != 0)
          })

          commit(SET_UPDATED_STATISTIC, data);

        })
      .catch(() => {
        commit(SET_ERROR_BRIGADES, true);
      });
    },

    async close_statistic({ commit, getters }, _id) {

      const totals = getters.get_totals;

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      _id.totals = totals

      instance
        .put(`/statistics/close`, _id)
        .then((r) => r.data)
        .then((result) => {
          commit(SET_STATUS, result.stat);
        });

      return { status: "good" };
    },

    async open_statistic({ commit, getters }, data) {
      const id = data._id

      const instance = await axios.create({
        baseURL: uri,
        headers: {
          "Content-Type": "application/json",
          "X-token": localStorage.getItem("_token"),
          title: localStorage.getItem("title"),
          _id: localStorage.getItem("_id"),
        },
      });

      instance
        .put(`/statistics/open`, data)
        .then((r) => r.data)
        .then(() => {

          commit(DELETE_ARCHIVE, id);

        });

      return { status: "good" };
    },

    async load_bridades({ commit }, data) {
      console.log(data);
      const instance = await axios.create({
          baseURL: uri,
          headers: {
              "Content-Type": "application/json",
              "X-token": localStorage.getItem("_token"),
              "title": localStorage.getItem("title"),
              "_id": localStorage.getItem("_id"),
          },
      });

      instance
      .get(`/brigades/${data.year}/${data.month}`)
      .then(r => r.data)
      .then(data => {
          commit(SET_BRIGADES, data)
      }).catch(err => {
          if (err.response.status == 401)
              router.push("/statistic")
      })
    },

    async load_bridades_by_date({ commit }, date) {
      const instance = await axios.create({
          baseURL: uri,
          headers: {
              "Content-Type": "application/json",
              "X-token": localStorage.getItem("_token"),
              "title": localStorage.getItem("title"),
              "_id": localStorage.getItem("_id"),
          },
      });

      instance
      .get(`/brigades/${date}`)
      .then(r => r.data)
      .then(data => {
          commit(SET_BRIGADES_BY_DATE, data)
      }).catch(err => {
          if (err.response.status == 401)
              router.push("/statistic")
      })
    },

    async update_dpf({ commit }, data) {
      const instance = await axios.create({
          baseURL: uri,
          headers: {
              "Content-Type": "application/json",
              "X-token": localStorage.getItem("_token"),
              "title": localStorage.getItem("title"),
              "_id": localStorage.getItem("_id"),
          },
      });

      instance
          .post(`${uri}/brigades/update-dpf`, data)
          .then(r => r.data)
          .then(result => {

              console.log(result);
              commit(SET_BRIGADE_BY_DATE, data)
              
          }).catch(err => {
              console.log(err.message);

          })

      return { status: 'good' }
  },

    
  },
};

export default statisticStore;
